<template>
  <v-container style="padding: 0;">
    <v-btn :disabled="loading || !selectedBudgets.length" color="success" depressed size="small" @click="getPDF()"
      :loading="loading">
      <v-icon left>mdi-printer</v-icon> Ficha Sintética
    </v-btn>
  </v-container>
</template>
<script>
import api from "@/http";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import UtilsPDF from '../../../service/utilsPDF';
import UtilsFunc from "../../../service/utilsFunc";
import logo from "../../../assets/logo.png";
import gptw from "../../../assets/GPTW_2023-2024.png";
import ona from "../../../assets/ONA_Nivel_3.png";

const { withCRUDUtils } = UtilsFunc
export default {
  name: "Ficha_Sintetica",
  data: () => withCRUDUtils({
    loading: false,
    captacao: [],
    paciente: [],
    quandroclinico: [],
    assinaturas: [],
    meta:[],
  }),
  props: {
    selectedBudgets: {
      type: Array,
      default: () => []
    },
    username: String
  },
  methods: {
    async getPDF() {
      this.loading = true;
      this.$toast.success(
        `O documento está sendo preparado. Isso pode levar alguns instantes. Aguarde, por favor.`
      );
      try {
        // Primeiro, carregue o orçamento e o endereço, depois a captação
        await this.getPaciente(); // Aguarde o carregamento do endereço
        await this.getQuadroClinico()
        await this.getCaptacao();
        await this.getMeta();
        await this.getTrocaDispositivo();
        
        // Certifique-se de que o PDF foi gerado antes de salvar
        await this.generatePDF();
        this.savePDF();
        this.loading = false;
      } catch (error) {
        this.$toast.error("Erro ao carregar os dados:", error);
        this.loading = false;
      }
    },
    drawHeader(doc) {
      // const captacao = this.captacao[0]
      const paciente = this.paciente[0]
      const pageWidth = 210;
      // const yFixedPosition = 100;

      try {
        UtilsPDF.logomarcaMedia(doc);
      } catch (error) {
        this.$toast.error("Falha ao adicionar a imagem ao PDF:", error);
      }
      doc.setFont("helvetica", "normal");
      doc.setDrawColor(57, 106, 159);
      doc.setLineWidth(1);
      doc.line(5, 5, 205, 5);

      // Ajustar a coordenada 'rectY' para mover o retângulo para cima
      doc.setLineWidth(0.5);
      const rectX = 3;
      const rectY = 40;  // Diminuir este valor para mover o retângulo para cima (era 40)
      const rectWidth = 204;
      const rectHeight = 77;  // Aumente este valor para aumentar a altura do retângulo
      const borderRadius = 2;
      doc.roundedRect(rectX, rectY, rectWidth, rectHeight, borderRadius, borderRadius, "S");

      doc.setDrawColor(0, 0, 0);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text("São Luís Home Care", 105, 15, { align: "center" });
      doc.setFont("helvetica", "normal");
      doc.setFontSize(16);
      doc.text(`FICHA SINTÉTICA`, 105, 31, { align: "center" });

      moment.locale("pt-br");

      const currentDate = new Date();
      const hour = moment(currentDate).format("HH:mm");
      const xFixedPosition = 10;
      const lineHeight = 6

      doc.setFontSize(8);
      if (this.username && this.username.trim()) {
        doc.text(`Gerado por: ${this.username}`, 200, 28, { align: "right"});
      }
      doc.text("Data e Hora da Impressão:", 200, 32, { align: "right" });
      doc.text(`${UtilsPDF.formatDate(currentDate)} às ${hour}`, 200, 36, { align: "right", });
      doc.text(`FORM: 052`, 200, 39, { align: "right", });

      // doc.setFontSize(11);
      // doc.text(`Avaliado em: ${UtilsPDF.formatDate(captacao?.captacao?.data_avaliacao)}`, 81, 32);

      let yPosition = 48

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      const textWidth1 = doc.getTextWidth("DADOS DO PACIENTE");
      const xCenteredPosition1 = pageWidth / 2 - textWidth1 / 2;
      doc.text("DADOS DO PACIENTE", xCenteredPosition1, yPosition);

      yPosition += lineHeight + 2
      
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text( `Paciente: ${paciente.nome ?? ''} `, xFixedPosition, yPosition );
      
      const dataNascimento = this.selectedBudgets[0].data_nascimento 
                ? `Data Nascimento: ${UtilsPDF.formatDate(this.selectedBudgets[0].data_nascimento)}` 
                : 'Data Nascimento: ';
      
      doc.text( dataNascimento,  200,  yPosition,  { align: "right" } );
      
      doc.setFont("helvetica", "normal");
      
      yPosition += lineHeight
      doc.text(`ID: ${paciente.id ? paciente.id : 'Não Cadastrado'}  -  CPF: ${paciente.cpf ? paciente.cpf : 'Não Cadastrado'}  -  RG: ${paciente.rg ? paciente.rg : 'Não Cadastrado'}  -  Sexo: ${paciente.sexo_biologico ? paciente.sexo_biologico : 'Não Cadastrado'}`, xFixedPosition, yPosition);

      yPosition += lineHeight
      doc.text(`Endereço: ${paciente.endereco.logradouro ?? 'Não Cadastrado'}, ${paciente.endereco.nr ?? 'Não Cadastrado'}, ${paciente.endereco.bairro ?? 'Não Cadastrado'}, ${paciente.endereco.cidade ?? 'Não Cadastrado'} / ${paciente.endereco.estado ?? 'Não Cadastrado'} - CEP:${paciente.endereco.cep ? paciente.endereco.cep : 'Não Cadastrado'}`, xFixedPosition, yPosition);
     
      yPosition += lineHeight
      doc.text(`Referência:${paciente.endereco.referencia ? paciente.endereco.referencia : 'Não Cadastrado'}`, xFixedPosition, yPosition);
      
      yPosition += lineHeight
      doc.text(`Responsável: ${paciente.responsavel ?? 'Não Cadastrado'}      -      Telefone: ${paciente.telefone ?? 'Não Cadastrado'}`, xFixedPosition, yPosition);

      yPosition += lineHeight
      doc.text(`Etnia: ${paciente.etinia ?? 'Não Cadastrado'}      -    Religião: ${paciente.religiao ?? 'Não Cadastrado'}      -      Profissão: ${paciente.profissao ?? 'Não Cadastrado'}`, xFixedPosition, yPosition);
      
      yPosition += lineHeight
      doc.text(`Estado Civil: ${paciente.estado_civil ?? 'Não Cadastrado'}`, xFixedPosition, yPosition);
      
      yPosition += lineHeight
      const operadora = this.selectedBudgets[0].operadora.nome || 'Não Cadastrado';
            doc.text(`Operadora: ${operadora}`, xFixedPosition, yPosition);

      const nrCarteirinha = this.selectedBudgets[0].nr_carteirinha || 'Não Cadastrado';
            doc.text(`Nº da Carteira: ${nrCarteirinha}`, 200, yPosition, { align: "right" });

      yPosition += lineHeight

      const cid = this.selectedBudgets[0].cid?.nome || 'Não Cadastrado';

      if (cid && cid.length > 0) {
          const cidDescricao = this.selectedBudgets[0].cid.descricao || 'Não Cadastrado';
          const fullText = `CID: ${cid} - ${cidDescricao}`;

          const splittedText = doc.splitTextToSize(fullText, rectWidth - 10);

          splittedText.forEach((line, i) => {
              doc.text(line, xFixedPosition, yPosition + (lineHeight * i));
          });

          yPosition += (lineHeight * splittedText.length);
      } else {
          doc.setFont("helvetica", "normal");
          doc.text(`CID: `, xFixedPosition, yPosition);
      }

      yPosition += lineHeight
    
    },
    async download(dataurl, filename) {
      const httpsurl = !dataurl.includes("https") ? dataurl.replace("http", "https") : dataurl
      const res = await fetch(httpsurl)
      const buffer = await res.blob()
      const url = URL.createObjectURL(buffer)
      const link = document.createElement("a");
      link.download = filename;
      link.href = url;
      link.click();
    },
    async savePDF() {
      const paciente = this.paciente[0];
      const filename = `Ficha_Sintetica_${paciente.nome.replace(/\s+/g, '_')}_${this.selectedBudgets[0].operadora.nome.replace(/\s+/g, '_')}.pdf`;
      // Gera o PDF
      await this.generatePDF();
    // Salva o PDF gerado como um arquivo no lado do cliente
      const pdfBuffer = this.doc.output('arraybuffer');
      const pdfBlob = new Blob([pdfBuffer], { type: "application/pdf" });
      const url = URL.createObjectURL(pdfBlob);
      
      // Cria um link temporário para realizar o download do arquivo
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;

      // Simula o clique no link para iniciar o download
      document.body.appendChild(link);
      link.click();

      // Remove o link após o download
      document.body.removeChild(link);

      this.$toast.success('O download do relatório foi realizado com sucesso!');
    },

    async generatePDF() {
      const doc = new jsPDF({ compress: true });
      this.drawHeader(doc);
      
      let yPosition = 121;
  
    // Definição da largura de 90% da página
      const fullWidth = 200;
      const startX = (210 - fullWidth) / 2; // Centraliza o retângulo horizontalmente
      let lineHeight = 5; // A altura da linha para o texto "GRUPO 1 – ELEGIBILIDADE"
      // const pageWidth = doc.internal.pageSize.getWidth();

      const checkPageBreak = (doc, yPosition, additionalHeight = 0) => {
        const pageHeight = doc.internal.pageSize.height; // Altura da página
        const marginBottom = 20; // Espaço mínimo necessário no final da página

        if (yPosition + additionalHeight > pageHeight - marginBottom) {
            doc.addPage(); // Adiciona uma nova página
            // this.drawHeader(doc); // Redesenha o cabeçalho
                    try {
                      doc.addImage(logo, 10, 8, 28, 28);
                      doc.addImage(ona, 160, 10, 15, 15);
                      doc.addImage(gptw, 185, 10, 15, 15);
                    } catch (error) {
                      this.$toast.error("Falha ao adicionar a imagem ao PDF (L-61):", error);
                    }
                    doc.setFont("helvetica", "normal");
                    doc.setDrawColor(57, 106, 159);
                    doc.setLineWidth(1);
                    doc.line(5, 5, 205, 5);

                    doc.setDrawColor(0, 0, 0);
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(18);
                    doc.text("São Luís Home Care", 105, 15, { align: "center" });
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(16);
                    doc.text(`FICHA SINTÉTICA`, 105, 23, { align: "center" });

                    moment.locale("pt-br");

                    const currentDate = new Date();
                    const hour = moment(currentDate).format("HH:mm");
                    const lineHeight = 6

                    doc.setFontSize(8);
                    doc.text(`Gerado por: ${this.username}`, 200, 28, { align: "right"});
                    doc.text("Data e Hora da Impressão:", 200, 32, { align: "right" });
                    doc.text(`${UtilsPDF.formatDate(currentDate)} às ${hour}`, 200, 36, { align: "right", });
                    doc.text(`FORM: 130`, 200, 39, { align: "right", });
            yPosition += lineHeight
    
            return 42; // Retorna a nova posição Y no topo da página seguinte
        }
        return yPosition;
    };

      // Exemplo de uso da verificação de quebra de página antes de desenhar elementos
      // yPosition = checkPageBreak(doc, yPosition, lineHeight);

      // Desenha o retângulo com 90% da largura da página
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(57, 106, 159);  // Azul para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

//RESUMO DO QUADRO CLÍNICO
      // Desenha o retângulo com 90% da largura da página
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(57, 106, 159);  // Azul para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      doc.setTextColor(255, 255, 255);  // Texto branco
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      const textWidth8 = doc.getTextWidth("RESUMO DO QUADRO CLÍNICO");
      const textXPosition8 = startX + (fullWidth / 2) - (textWidth8 / 2);
      doc.text("RESUMO DO QUADRO CLÍNICO", textXPosition8, yPosition + lineHeight / 2 + 1);
      // doc.text("RESUMO DO QUADRO CLÍNICO:", startX + 5, yPosition + lineHeight / 2 + 1); // Adiciona um pequeno espaçamento à esquerda com +5

      yPosition += lineHeight ;
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(255, 255, 255);  // Branco para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      // let quadroclinico = 'O Lead (ou, na forma aportuguesada, Lide) é, em jornalismo, a primeira parte de uma notícia, geralmente posta em destaquerelativo, que fornece ao leitor a informação básica sobre o tema e pretende prender-lhe o interesse. É uma expressão inglesa quesignifica "guia" ou "o que vem à frente". Pode partir de 6 perguntinhas básicas: "O quê" e/ou "Quem?", "Quando?", "Onde?", "Como?", e "Por quê?“. A ideia é responder essas perguntas na primeira parte da notícia (ou algumas delas). Os outros parágrafos são o desenvolvimento do que é citado no Lead. O Lead (ou, na forma aportuguesada, Lide) é, em jornalismo, a primeira parte de uma notícia, geralmente posta em destaquerelativo, que fornece ao leitor a informação básica sobre o tema e pretende prender-lhe o interesse. É uma expressão inglesa quesignifica "guia" ou "o que vem à frente". Pode partir de 6 perguntinhas básicas: "O quê" e/ou "Quem?", "Quando?", "Onde?", "Como?", e "Por quê?“. A ideia é responder essas perguntas na primeira parte da notícia (ou algumas delas). Os outros parágrafos são o desenvolvimento do que é citado no Lead. O Lead (ou, na forma aportuguesada, Lide) é, em jornalismo, a primeira parte de uma notícia, geralmente posta em destaquerelativo, que fornece ao leitor a informação básica sobre o tema e pretende prender-lhe o interesse. É uma expressão inglesa quesignifica "guia" ou "o que vem à frente". Pode partir de 6 perguntinhas básicas: "O quê" e/ou "Quem?", "Quando?", "Onde?", "Como?", e "Por quê?“. A ideia é responder essas perguntas na primeira parte da notícia (ou algumas delas). Os outros parágrafos são o desenvolvimento do que é citado no Lead. O Lead (ou, na forma aportuguesada, Lide) é, em jornalismo, a primeira parte de uma notícia, geralmente posta em destaquerelativo, que fornece ao leitor a informação básica sobre o tema e pretende prender-lhe o interesse. É uma expressão inglesa quesignifica "guia" ou "o que vem à frente". Pode partir de 6 perguntinhas básicas: "O quê" e/ou "Quem?", "Quando?", "Onde?", "Como?", e "Por quê?“. A ideia é responder essas perguntas na primeira parte da notícia (ou algumas delas). Os outros parágrafos são o desenvolvimento do que é citado no Lead.';
      let quadroclinico = this.quadroclinico.quadro_clinico
 
      // Verifica se há dados para mostrar; se não, exibe "Sem Relatos"
      if (quadroclinico) {
        doc.setTextColor(0, 0, 0);  // Texto preto
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        
        // Quebra o texto em várias linhas, se necessário, com base na largura do retângulo
        const splittedText = doc.splitTextToSize(quadroclinico, fullWidth - 10);
        // Calcula a altura total necessária para o retângulo com base no número de linhas
        const dynamicHeight = lineHeight * splittedText.length;

        // Desenha o retângulo ajustado à altura necessária
        doc.rect(startX, yPosition, fullWidth, dynamicHeight, 'FD');
        
        // Renderiza o texto quebrado linha por linha
        splittedText.forEach(line => {
          doc.text(line, startX + 5, yPosition + lineHeight / 2 + 1);
          yPosition += lineHeight; 
          yPosition = checkPageBreak(doc, yPosition, lineHeight); // Ajusta a posição vertical para a próxima linha
        });
      } else {
        doc.setTextColor(0, 0, 0);  // Texto preto
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text("Sem Relatos", startX + 5, yPosition + lineHeight / 2 + 1);
        yPosition += lineHeight;
      }
       yPosition += lineHeight;
       yPosition = checkPageBreak(doc, yPosition, lineHeight * 2);

//ALERGIA
      // Desenha o retângulo com 90% da largura da página
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(57, 106, 159);  // Azul para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      doc.setTextColor(255, 255, 255);  // Texto branco
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      const textWidth3 = doc.getTextWidth("ALERGIA");
      const textXPosition3 = startX + (fullWidth / 2) - (textWidth3 / 2);
      doc.text("ALERGIA", textXPosition3, yPosition + lineHeight / 2 + 1);
      // doc.text("RESUMO DO QUADRO CLÍNICO:", startX + 5, yPosition + lineHeight / 2 + 1); // Adiciona um pequeno espaçamento à esquerda com +5

      yPosition += lineHeight ;
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(255, 255, 255);  // Branco para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      // let quadroclinico = 'O Lead (ou, na forma aportuguesada, Lide) é, em jornalismo, a primeira parte de uma notícia, geralmente posta em destaquerelativo, que fornece ao leitor a informação básica sobre o tema e pretende prender-lhe o interesse. É uma expressão inglesa quesignifica "guia" ou "o que vem à frente". Pode partir de 6 perguntinhas básicas: "O quê" e/ou "Quem?", "Quando?", "Onde?", "Como?", e "Por quê?“. A ideia é responder essas perguntas na primeira parte da notícia (ou algumas delas). Os outros parágrafos são o desenvolvimento do que é citado no Lead. O Lead (ou, na forma aportuguesada, Lide) é, em jornalismo, a primeira parte de uma notícia, geralmente posta em destaquerelativo, que fornece ao leitor a informação básica sobre o tema e pretende prender-lhe o interesse. É uma expressão inglesa quesignifica "guia" ou "o que vem à frente". Pode partir de 6 perguntinhas básicas: "O quê" e/ou "Quem?", "Quando?", "Onde?", "Como?", e "Por quê?“. A ideia é responder essas perguntas na primeira parte da notícia (ou algumas delas). Os outros parágrafos são o desenvolvimento do que é citado no Lead. O Lead (ou, na forma aportuguesada, Lide) é, em jornalismo, a primeira parte de uma notícia, geralmente posta em destaquerelativo, que fornece ao leitor a informação básica sobre o tema e pretende prender-lhe o interesse. É uma expressão inglesa quesignifica "guia" ou "o que vem à frente". Pode partir de 6 perguntinhas básicas: "O quê" e/ou "Quem?", "Quando?", "Onde?", "Como?", e "Por quê?“. A ideia é responder essas perguntas na primeira parte da notícia (ou algumas delas). Os outros parágrafos são o desenvolvimento do que é citado no Lead. O Lead (ou, na forma aportuguesada, Lide) é, em jornalismo, a primeira parte de uma notícia, geralmente posta em destaquerelativo, que fornece ao leitor a informação básica sobre o tema e pretende prender-lhe o interesse. É uma expressão inglesa quesignifica "guia" ou "o que vem à frente". Pode partir de 6 perguntinhas básicas: "O quê" e/ou "Quem?", "Quando?", "Onde?", "Como?", e "Por quê?“. A ideia é responder essas perguntas na primeira parte da notícia (ou algumas delas). Os outros parágrafos são o desenvolvimento do que é citado no Lead.';
      let alergia = this.paciente[0].alergia
 
      // Verifica se há dados para mostrar; se não, exibe "Sem Relatos"
      if (alergia) {
        doc.setTextColor(0, 0, 0);  // Texto preto
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        
        // Quebra o texto em várias linhas, se necessário, com base na largura do retângulo
        const splittedText = doc.splitTextToSize(alergia, fullWidth - 10);
        // Calcula a altura total necessária para o retângulo com base no número de linhas
        const dynamicHeight = lineHeight * splittedText.length;

        // Desenha o retângulo ajustado à altura necessária
        doc.rect(startX, yPosition, fullWidth, dynamicHeight, 'FD');
        
        // Renderiza o texto quebrado linha por linha
        splittedText.forEach(line => {
          doc.text(line, startX + 5, yPosition + lineHeight / 2 + 1);
          yPosition += lineHeight; 
          yPosition = checkPageBreak(doc, yPosition, lineHeight); // Ajusta a posição vertical para a próxima linha
        });
      } else {
        doc.setTextColor(0, 0, 0);  // Texto preto
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text("Sem Relatos", startX + 5, yPosition + lineHeight / 2 + 1);
        yPosition += lineHeight;
      }
       yPosition += lineHeight;
       yPosition = checkPageBreak(doc, yPosition, lineHeight * 2);

//DADOS COMPLEMENTAERES
      // Desenha o retângulo com 90% da largura da página
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(57, 106, 159);  // Azul para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      doc.setTextColor(255, 255, 255);  // Texto branco
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      const textWidth5 = doc.getTextWidth("DADOS COMPLEMENTARES");
      const textXPosition5 = startX + (fullWidth / 2) - (textWidth5 / 2);
      doc.text("DADOS COMPLEMENTARES", textXPosition5, yPosition + lineHeight / 2 + 1);

      yPosition += lineHeight ;
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(255, 255, 255);  // Branco para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      // let historicoTrocaTQT = this.trocaDispositivoTQT.map(item => UtilsPDF.formatDate(item.data_troca)).join(', ');
      // let historicoTrocaGTT = this.trocaDispositivoGTT.map(item => UtilsPDF.formatDate(item.data_troca)).join(', ');
      let maiorDataTrocaTQT = UtilsPDF.formatDate(this.maiorDataTrocaTQT);
      let maiorDataTrocaGTT = UtilsPDF.formatDate(this.maiorDataTrocaGTT);
      let maiorDataProximaTrocaTQT = UtilsPDF.formatDate(this.maiorDataProximaTrocaTQT)
      let maiorDataProximaTrocaGTT = UtilsPDF.formatDate(this.maiorDataProximaTrocaGTT)
      // let trocaDispositivoGTT = this.trocaDispositivoGTT 
      // let ultimaTrocaTQT = this.ultimaTrocaTQT
      // let ultimaTrocaGTT = this.ultimaTrocaGTT
      // Verifica se os dados de Peso e Altura estão disponíveis e exibe as informações
      doc.setFontSize(10);
      let peso = this.paciente[0].peso ? `Peso: ${this.paciente[0].peso} kg` : 'Peso: Não Cadastrado';
      let altura = this.paciente[0].altura ? `Altura: ${this.paciente[0].altura} m` : 'Altura: Não Cadastrada';
      let liminar = this.paciente[0].liminar ? `Liminar : Sim` : `Liminar: Não`;
      let paliativo = this.paciente[0].paliativo ? `Paliativo : Sim` : `Paliativo: Não`;
      let respirador = this.paciente[0].respirador ? `Possui Respirador: Sim; ${this.paciente[0]?.tipo_ventilador_mecanico?.tipo ? `Tipo de Respirador: ${this.paciente[0]?.tipo_ventilador_mecanico?.tipo}` : ''}` : 'Possui Respirador: Não Cadastrado ou Não Possui';
      // let dadosrespirador = this.paciente[0].tipo_ventilador_mecanico ? `Tipo de Respirador: ${this.paciente[0]?.tipo_ventilador_mecanico?.tipo}` : ''
      let dadosrespirador2 = this.paciente[0].tipo_ventilador_mecanico ? `Modo Ventilatório: ${this.paciente[0]?.modo_ventilatorio?.tipo}; VC: ${this.paciente[0]?.ventilador_vc} ml; IPAP: ${this.paciente[0]?.ventilador_ipap} cmH2O; EPAP: ${this.paciente[0]?.ventilador_epap} cmH2O; FR: ${this.paciente[0]?.ventilador_fr} rpm; TINS: ${this.paciente[0]?.ventilador_tins} s.\n` : ''
      let tqt = this.paciente[0].tqt ? `Possui TQT: ${this.paciente[0].tqt.modelo} -> Nº: ${this.paciente[0].numeracao_tqt } `: '';
      let gtt = this.paciente[0].via_alimentacao_gtt? `Possui Sonda / GTT: ${this.paciente[0].via_alimentacao_gtt.tipo} -> Tamanho: ${this.paciente[0].tamanho_gtt } `: ''
      
      
      // Constrói a string de dados complementares
      let dadosComplementares = `${liminar} - ${paliativo} \n${altura} - ${peso} \n${respirador ? `${respirador} \n${dadosrespirador2}` : 'Possui Respirador: Não Cadastrado ou Não Possui'}${tqt} ${maiorDataTrocaTQT ? `,  Última Troca de TQT: ${maiorDataTrocaTQT} -> Próxima Troca Prevista para: ${maiorDataProximaTrocaTQT}` : ''}  \n${gtt} ${maiorDataTrocaGTT ? `,  Última Troca de TQT: ${maiorDataTrocaGTT} -> Próxima Troca Prevista para: ${maiorDataProximaTrocaGTT}` : ''}`;

      // Verifica se há dados para mostrar; se não, exibe "Não Cadastrada"
      if (dadosComplementares) {
          doc.setTextColor(0, 0, 0);  // Texto preto
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);

          // Quebra o texto em várias linhas, se necessário, com base na largura do retângulo
          const splittedText = doc.splitTextToSize(dadosComplementares, fullWidth - 20);
          // Calcula a altura total necessária para o retângulo com base no número de linhas
          const dynamicHeight = lineHeight * splittedText.length;

          // Desenha o retângulo ajustado à altura necessária
          doc.rect(startX, yPosition, fullWidth, dynamicHeight, 'FD');

          // Renderiza o texto quebrado linha por linha
          splittedText.forEach(line => {
              doc.text(line, startX + 5, yPosition + lineHeight / 2 + 1);
              yPosition += lineHeight;  // Ajusta a posição vertical para a próxima linha
          });
      } else {
          doc.setTextColor(0, 0, 0);  // Texto preto
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);
          doc.text("Não Cadastrado", startX + 5, yPosition + lineHeight / 2 + 1);
          yPosition += lineHeight;
      }
      yPosition += lineHeight;
      yPosition = checkPageBreak(doc, yPosition, lineHeight * 2);



// PLANO TERAPÊUTICO
      // Desenha o retângulo com 90% da largura da página
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(57, 106, 159);  // Azul para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo
      const today = new Date()

      doc.setTextColor(255, 255, 255);  // Texto branco
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      const textWidth2 = doc.getTextWidth(`PLANO TERAPÊUTICO VIGENTE EM ${UtilsPDF.formatDate(today)}`);
      const textXPosition2 = startX + (fullWidth / 2) - (textWidth2 / 2);
      doc.text(`PLANO TERAPÊUTICO VIGENTE EM ${UtilsPDF.formatDate(today)}`, textXPosition2, yPosition + lineHeight / 2 + 1);

      yPosition += lineHeight;
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(255, 255, 255);  // Branco para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      // Constrói a string do plano terapêutico com base nos dados recebidos
      let planoTerapeutico = this.paciente[0].plano_terapeutico.map(plano => {
          return `${plano.procedimento__procedimento__nome} - ${plano.frequencia__nome}`;
      });

      // Junta todos os itens do plano terapêutico em uma única string, separados por vírgula
      let planoTerapeuticoText = planoTerapeutico.join(', ');


      // Verifica se há dados para mostrar; se não, exibe "Sem Relatos"
      if (planoTerapeuticoText) {
        doc.setTextColor(0, 0, 0);  // Texto preto
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);

        // Quebra o texto em várias linhas, se necessário, com base na largura do retângulo
        const splittedText = doc.splitTextToSize(planoTerapeuticoText, fullWidth - 10);
        // Calcula a altura total necessária para o retângulo com base no número de linhas
        const dynamicHeight = lineHeight * splittedText.length;

        // Desenha o retângulo ajustado à altura necessária
        doc.rect(startX, yPosition, fullWidth, dynamicHeight, 'FD');

        // Renderiza o texto quebrado linha por linha
        splittedText.forEach(line => {
            doc.text(line, startX + 5, yPosition + lineHeight / 2 + 1);
            yPosition += lineHeight;  // Ajusta a posição vertical para a próxima linha
        });
      } else {
          doc.setTextColor(0, 0, 0);  // Texto preto
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);
          doc.text("Sem Orçamento Aprovado / Vigente", startX + 5, yPosition + lineHeight / 2 + 1);
      }

      yPosition += lineHeight; // Adiciona espaço extra após cada meta
      yPosition = checkPageBreak(doc, yPosition, lineHeight * 4); // Verifica se é necessário uma quebra de página

  // META
      // doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      // doc.setFillColor(57, 106, 159);  // Azul para o fundo
      // doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      // doc.setTextColor(255, 255, 255);  // Texto branco
      // doc.setFont("helvetica", "bold");
      // doc.setFontSize(10);
      // const textWidth6 = doc.getTextWidth("METAS");
      // const textXPosition6 = startX + (fullWidth / 2) - (textWidth6 / 2);
      // doc.text("METAS", textXPosition6, yPosition + lineHeight / 2 + 1);

      // yPosition += lineHeight;
      // doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      // doc.setFillColor(255, 255, 255);  // Branco para o fundo
      // doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      // // Alterar a cor do texto para preto novamente
      // doc.setTextColor(0, 0, 0);  // Texto preto após o título

      // Constrói a string das metas com base nos dados recebidos
      let metas = [];
      this.meta.texto_meta.forEach(item => {
        metas.push(`${item.especialidade} --> ${item.texto_meta}`);
      });

      // Junta todos os textos em uma única string
      const metasText = metas.join('\n');

      // Verifica se há dados para mostrar; se não, exibe "Sem Relatos"
      if (metasText) {
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);

        const renderMetasSection = (doc, startX, yPosition, lineHeight, fullWidth, metasText) => {
          // Quebra o texto de "Metas" em várias linhas
          const splittedText = doc.splitTextToSize(metasText, fullWidth - 10);
          const dynamicHeight = lineHeight * splittedText.length; // Calcula a altura total necessária

          // Verifica se há espaço suficiente na página atual
          const pageHeight = doc.internal.pageSize.height;
          const marginBottom = 20;

          if (yPosition + dynamicHeight > pageHeight - marginBottom) {
            doc.addPage(); // Adiciona uma nova página
            yPosition = 42; // Define a posição Y no topo da nova página
          }
          // Renderiza o cabeçalho "METAS"
  doc.setDrawColor(0, 0, 0); // Cor preta para as bordas
  doc.setFillColor(57, 106, 159); // Azul para o fundo
  doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo
  doc.setTextColor(255, 255, 255); // Texto branco
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  const textWidth6 = doc.getTextWidth("METAS");
  const textXPosition6 = startX + (fullWidth / 2) - (textWidth6 / 2);
  doc.text("METAS", textXPosition6, yPosition + lineHeight / 2 + 1);

  yPosition += lineHeight;

          // Desenha o retângulo para "Metas" com a altura ajustada
          doc.setDrawColor(0, 0, 0);
          doc.setFillColor(255, 255, 255); // Branco para o fundo
          doc.rect(startX, yPosition, fullWidth, dynamicHeight, 'FD');

          // Renderiza o texto das "Metas"
          doc.setTextColor(0, 0, 0); // Texto preto
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);
          splittedText.forEach(line => {
            doc.text(line, startX + 5, yPosition + lineHeight / 2 + 1);
            yPosition += lineHeight;
          });

          return yPosition;
        };

        // Uso da função renderMetasSection
        yPosition = renderMetasSection(doc, startX, yPosition, lineHeight, fullWidth, metasText);
      } else {
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text("Sem Relatos", startX + 5, yPosition + lineHeight / 2 + 1);
      }

      yPosition = checkPageBreak(doc, yPosition, lineHeight  / 2 + 1);
      UtilsPDF.addPageNumbers(doc);
      this.doc = doc;
    },
    async getCaptacao() {
      try {
        const { data } = await api.get(`atendimentos/app-evolucoes-nead_abemid/?paciente_id=${this.selectedBudgets[0].id}&captacao=true`);
        this.captacao = data;
        const casaDataWithValues = data.filter(item => item.captacao && Object.keys(item.captacao).length > 0);
        if (casaDataWithValues.length > 0) {
          const latestcasaData = casaDataWithValues.reduce((latest, current) => {
            return new Date(current.timestamp) > new Date(latest.timestamp) ? current : latest;
          });
          this.captacao = [latestcasaData];
          // console.log('captacao -> ', this.captacao)
        } else {
          this.captacao[0] = null;
          // console.log('captacao -> ', this.captacao)
        }
      } catch (error) {
        // this.$toast.error("Erro ao buscar os dados do captacao:", error);
      } 
    },
    async getPaciente() {
      try {
        const { data } = await api.get(`pacientes/detalhes/?paciente=${this.selectedBudgets[0].id}`);
        this.paciente = data;
        // console.log('PACIENTE --> ', this.paciente)
      } catch (error) {
        this.$toast.error("Erro ao buscar os dados do Endereço:", error);
      }
    },
    async getQuadroClinico() {
      try {
        const { data } = await api.get(`atendimentos/app-texto-quadroclinico/?paciente=${this.selectedBudgets[0].id}`);
          this.quadroclinico = data[0]
          // console.log('getQuadroClinico -> ', this.quadroclinico)
      } catch (error) {
        this.$toast.error("Erro ao buscar os dados da Quadro Clínico :", error);
      }
    },
    async getMeta() {
      try {
        const { data } = await api.get(`pacientes/app-offline/?paciente=${this.selectedBudgets[0].id}`);
          this.meta = data[0]
          // console.log('getMeta -> ', this.meta)
      } catch (error) {
        this.$toast.error("Erro ao buscar os dados das Metas :", error);
      }
    },
    async getTrocaDispositivo() {
      this.isLoading = true;
      try {
        const { data } = await api.get(`/pacientes/troca-dispositivos/?paciente=${this.selectedBudgets[0].id}`);
        // console.log(data)
        // Filtrar itens ativos
        const dispositivosAtivos = data.filter(item => item.ativo);
        // Separar por tqt = true e tqt = false
        const tqtTrue = dispositivosAtivos.filter(item => item.tqt === true);
        const tqtFalse = dispositivosAtivos.filter(item => item.tqt === false);
        // Ordenar pela data mais recente
        tqtTrue.sort((a, b) => new Date(b.data_troca) - new Date(a.data_troca));
        tqtFalse.sort((a, b) => new Date(b.data_troca) - new Date(a.data_troca));
        // Selecionar apenas os 3 últimos para cada tipo
        // this.trocaDispositivoTQT = tqtTrue.slice(0, 3); // Pega as 3 últimas trocas com tqt = true
        // // console.log('trocaDispositivoTQT', this.trocaDispositivoTQT)
        // this.trocaDispositivoGTT = tqtFalse.slice(0, 3); // Pega as 3 últimas trocas com tqt = false
        // // console.log('trocaDispositivoGTT', this.trocaDispositivoGTT)
        //  // Selecionar a troca com a maior data_troca para exibir "Próxima Troca Prevista"
        // this.ultimaTrocaTQT = tqtTrue.length > 0 ? tqtTrue[0] : null; // A troca mais recente para TQT
        // // console.log(this.ultimaTrocaTQT)
        // this.ultimaTrocaGTT = tqtFalse.length > 0 ? tqtFalse[0] : null; // A troca mais recente para GTT
        // // Encontrar a maior data_proxima_troca para TQT e GTT
        const maiorDataProximaTrocaTQT = tqtTrue
          .map(item => item.data_proxima_troca ? new Date(item.data_proxima_troca) : null)
          .filter(date => date !== null)
          .reduce((max, curr) => (curr > max ? curr : max), null); // Começa com uma data bem antiga

        const maiorDataTrocaTQT = tqtTrue
          .map(item => item.data_troca ? new Date(item.data_troca) : null)
          .filter(date => date !== null)
          .reduce((max, curr) => (curr > max ? curr : max), null); // Começa com uma data bem antiga
        
        const maiorDataProximaTrocaGTT = tqtFalse
          .map(item => item.data_proxima_troca ? new Date(item.data_proxima_troca) : null)
          .filter(date => date !== null)
          .reduce((max, curr) => (curr > max ? curr : max), null);

        const maiorDataTrocaGTT = tqtFalse
          .map(item => item.data_troca ? new Date(item.data_troca) : null)
          .filter(date => date !== null)
          .reduce((max, curr) => (curr > max ? curr : max), null);

        // Grava a maior data de data_proxima_troca para TQT e GTT
        this.maiorDataProximaTrocaTQT = maiorDataProximaTrocaTQT ? maiorDataProximaTrocaTQT : '';
        this.maiorDataProximaTrocaGTT = maiorDataProximaTrocaGTT ? maiorDataProximaTrocaGTT : '';
        this.maiorDataTrocaTQT = maiorDataTrocaTQT ? maiorDataTrocaTQT : '';
        this.maiorDataTrocaGTT = maiorDataTrocaGTT ? maiorDataTrocaGTT : '';

      } catch (error) {
        this.$toast.error(`Desculpe! Aconteceu algo errado ao buscar os itens de Troca de Dispositivos. Deu erro ${error}`);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>